"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[63505],{

/***/ 230290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ RelatedPromotion; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(634655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(857387);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(853675);
/* harmony import */ var components_ProductDetail_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(243290);






const renderDetailPromotionContent = (benefitType, data)=>{
    switch(benefitType){
        case _types__WEBPACK_IMPORTED_MODULE_2__/* .BENEFIT_TYPE.discount */ .s.discount:
            const { percent , maxAmount , flat  } = data;
            return percent !== null ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    (0,i18n__WEBPACK_IMPORTED_MODULE_3__.t)("{{percent}}% tối đa", {
                        percent: percent
                    }),
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ProductDetail_styles__WEBPACK_IMPORTED_MODULE_4__/* .StyledCurrency */ .DY, {
                        value: maxAmount || 0
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ProductDetail_styles__WEBPACK_IMPORTED_MODULE_4__/* .StyledCurrency */ .DY, {
                value: flat || 0
            });
        case _types__WEBPACK_IMPORTED_MODULE_2__/* .BENEFIT_TYPE.gifts */ .s.gifts:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                children: data.map((param)=>{
                    let { name , quantity  } = param;
                    return "".concat(quantity, " ").concat(name);
                }).join(", ")
            });
        case _types__WEBPACK_IMPORTED_MODULE_2__/* .BENEFIT_TYPE.voucher */ .s.voucher:
            const { quantity , name  } = data;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                children: name ? "".concat(quantity, " ").concat(name) : "Voucher"
            });
        default:
            return null;
    }
};
const RelatedPromotion = (param)=>{
    let { promotion  } = param;
    const { isDefault , benefit , condition , promotionType , type  } = promotion;
    const { data , type: benefitType  } = benefit;
    // Magento
    if (promotionType === _types__WEBPACK_IMPORTED_MODULE_2__/* .PROMOTION_TYPE.magento */ .j.magento) {
        const { coupon , benefit: benefit1 , extraCondition , url  } = data;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                (0,i18n__WEBPACK_IMPORTED_MODULE_3__.t)("Nhập m\xe3"),
                " ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                    children: coupon
                }),
                " ",
                (0,i18n__WEBPACK_IMPORTED_MODULE_3__.t)("giảm th\xeam"),
                " ",
                benefit1.discountPercent,
                (0,i18n__WEBPACK_IMPORTED_MODULE_3__.t)("% tối đa"),
                " ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ProductDetail_styles__WEBPACK_IMPORTED_MODULE_4__/* .StyledCurrency */ .DY, {
                    value: benefit1.maxDiscount
                }),
                extraCondition,
                " ",
                (0,i18n__WEBPACK_IMPORTED_MODULE_3__.t)("khi thanh to\xe1n qua VNPAY-QR."),
                url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ProductDetail_styles__WEBPACK_IMPORTED_MODULE_4__/* .Link */ .rU, {
                    href: url,
                    target: "blank",
                    children: (0,i18n__WEBPACK_IMPORTED_MODULE_3__.t)("Xem chi tiết")
                })
            ]
        });
    }
    // Custom magento
    if (promotionType === _types__WEBPACK_IMPORTED_MODULE_2__/* .PROMOTION_TYPE.customMagento */ .j.customMagento) {
        const { text , url: customUrl  } = data;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    dangerouslySetInnerHTML: {
                        __html: text
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ProductDetail_styles__WEBPACK_IMPORTED_MODULE_4__/* .Link */ .rU, {
                    href: customUrl,
                    target: "blank",
                    children: (0,i18n__WEBPACK_IMPORTED_MODULE_3__.t)("Xem chi tiết")
                })
            ]
        });
    }
    const isDiscount = benefitType === "discount";
    const renderPrefixText = ()=>{
        if (isDefault || type !== "coupon") {
            return isDiscount ? (0,i18n__WEBPACK_IMPORTED_MODULE_3__.t)("Giảm") : (0,i18n__WEBPACK_IMPORTED_MODULE_3__.t)("Tặng");
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                (0,i18n__WEBPACK_IMPORTED_MODULE_3__.t)("Nhập m\xe3"),
                " ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                    children: (condition === null || condition === void 0 ? void 0 : condition.coupon) || ""
                }),
                " ",
                isDiscount ? (0,i18n__WEBPACK_IMPORTED_MODULE_3__.t)("giảm") : (0,i18n__WEBPACK_IMPORTED_MODULE_3__.t)("tặng")
            ]
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
        children: [
            renderPrefixText(),
            " ",
            renderDetailPromotionContent(benefitType || "", data),
            " ",
            (0,i18n__WEBPACK_IMPORTED_MODULE_3__.t)("cho đơn h\xe0ng"),
            " ",
            !!(condition === null || condition === void 0 ? void 0 : condition.orderValueMin) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    (0,i18n__WEBPACK_IMPORTED_MODULE_3__.t)("từ"),
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Currency */ .F, {
                        value: condition.orderValueMin
                    })
                ]
            }),
            !!(condition === null || condition === void 0 ? void 0 : condition.orderValueMax) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    " ",
                    (0,i18n__WEBPACK_IMPORTED_MODULE_3__.t)("đến"),
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Currency */ .F, {
                        value: condition.orderValueMax
                    })
                ]
            }),
            " ",
            !!(condition === null || condition === void 0 ? void 0 : condition.hasProductCondition) && (0,i18n__WEBPACK_IMPORTED_MODULE_3__.t)("c\xf3 sản phẩm n\xe0y"),
            isDefault && (0,i18n__WEBPACK_IMPORTED_MODULE_3__.t)("sites.shop-front.components.RelatedPromotion.0")
        ]
    });
};


/***/ }),

/***/ 463505:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ProductRelatedPromotions": function() { return /* binding */ ProductRelatedPromotions; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(634655);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(534924);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(170604);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var components_ProductDetail_styles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(243290);
/* harmony import */ var components_RelatedPromotion__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(230290);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(329944);
/* harmony import */ var _teko_types_shared__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(184019);
/* harmony import */ var components_RelatedPromotionV2__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(590498);










const ProductRelatedPromotions = (param)=>{
    let { extraPromotions  } = param;
    const { product , price  } = (0,contexts__WEBPACK_IMPORTED_MODULE_3__/* .useProductDetailState */ .W)();
    const { validPromotions  } = (0,hooks__WEBPACK_IMPORTED_MODULE_4__/* .useDetailPromotion */ .n)(product, price === null || price === void 0 ? void 0 : price.finalPrice);
    const showAllPromotion = [
        ...validPromotions,
        ...extraPromotions || []
    ];
    return !!(showAllPromotion === null || showAllPromotion === void 0 ? void 0 : showAllPromotion.length) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Divider */ .i, {
                dividerStyle: _teko_types_shared__WEBPACK_IMPORTED_MODULE_2__/* .DividerStyleEnum.dashed */ .fd.dashed,
                margin: [
                    "s12",
                    "s0"
                ],
                color: "divider"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_ProductDetail_styles__WEBPACK_IMPORTED_MODULE_6__/* .RelatedPromotions */ .g$, {
                className: "BOXKHUYENMAILIENQUAN",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ProductDetail_styles__WEBPACK_IMPORTED_MODULE_6__/* .Title */ .Dx, {
                        children: (0,i18n__WEBPACK_IMPORTED_MODULE_7__.t)("Khuyến m\xe3i li\xean quan")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                        children: [
                            validPromotions.map((promotion, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_RelatedPromotionV2__WEBPACK_IMPORTED_MODULE_8__/* .RelatedPromotionV2 */ .u, {
                                        validPromotion: promotion
                                    })
                                }, index)),
                            extraPromotions === null || extraPromotions === void 0 ? void 0 : extraPromotions.map((promotion, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_RelatedPromotion__WEBPACK_IMPORTED_MODULE_9__/* .RelatedPromotion */ .e, {
                                        promotion: promotion
                                    })
                                }, index))
                        ]
                    })
                ]
            })
        ]
    }) : null;
};


/***/ })

}]);